// extracted by mini-css-extract-plugin
module.exports = {"boxTitle":"BoxTitle_boxTitle__2AN4g","title":"BoxTitle_title__SmsvR","row":"BoxTitle_row__1DvCL"};